export default __webpack_public_path__ + "images/search.v-8a4f56c9493a750a36984c6f9aedf58a.svg";